import { FC, useState } from 'react';
import { SearchableProvider } from '../../../../lib/components/SearchableDataTable/SearchableProvider';
import { PageLayout } from '../../../../lib/shell/PageLayout/PageLayout';
import { ContractDatatableModal } from '../client_contracts/components/ContractDataTableModal';
import { PartnersDatatable } from '../components/PartnersDatatable';

const partner_init = {
	id: '',
	name: '',
};

export const PartnerListPage: FC = () => {
	const [show_contracts, set_show_contracts] = useState(false);
	const [partner, set_client] = useState(partner_init);

	return (
		<SearchableProvider
			{...{
				entity_name: 'admin-plat-clients-config',
				default_query: {
					limit: 20,
					page: 1,
					sort: 'sort1',
					sort_dir: 'asc',
					tags: '',
					text: '',
					filters: {
						profile: 2,
					},
				},
			}}
		>
			<PageLayout title='Fórum Assinaturas'>
				<PartnersDatatable
					{...{
						set_show_contracts_list: () => set_show_contracts(true),
						set_client,
					}}
				/>
			</PageLayout>
			<ContractDatatableModal
				{...{ visible: show_contracts, close: () => set_show_contracts(false), partner }}
			/>
		</SearchableProvider>
	);
};
